import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetChangeRequestDetailsAsync,
  IChangeRequestDetails,
} from "../../api/IChangeRequests";
import { RootState } from "../store";

export interface ChangeRequestState {
  fetchStatus: string;
  changeRequest?: IChangeRequestDetails;
}

const initialState: ChangeRequestState = {
  fetchStatus: "Loading...",
  changeRequest: undefined,
};

export const loadChangeRequestAsync = createAsyncThunk(
  "changeRequest/load",
  async (changeRequestId: string) => {
    const response = await GetChangeRequestDetailsAsync(changeRequestId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const changeRequestSlice = createSlice({
  name: "changeRequest",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadChangeRequestAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadChangeRequestAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.changeRequest = action.payload;
      });
  },
});

export const selectChangeRequest = (state: RootState) => state.changeRequest;

export default changeRequestSlice.reducer;
